import { render, staticRenderFns } from "./FacilityCollectionsManagement.vue?vue&type=template&id=64bf1bee&scoped=true&"
import script from "./FacilityCollectionsManagement.vue?vue&type=script&lang=ts&"
export * from "./FacilityCollectionsManagement.vue?vue&type=script&lang=ts&"
import style0 from "./FacilityCollectionsManagement.vue?vue&type=style&index=0&id=64bf1bee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bf1bee",
  null
  
)

export default component.exports